import styled from 'styled-components';

export const Button = styled.button`
  display: inline-block;
  padding: 6px;

  border: 1px solid black;
  border-radius: 4px;

  line-height: 0;
  cursor: pointer;

  &:hover {
    border-color: ${(p): string => p.theme.colors?.colorGray2 || ''};

    & > svg > path {
      fill: ${(p): string => p.theme.colors?.colorGray2 || ''};
    }
  }

  svg {
    width: 16px;
    height: 16px;
  }
`;
